export default __webpack_public_path__ + "static/Brett.BlethenViceChairMembership_social-d9ddb16d1aa01c3cf561b100aa4ceeea.jpg";